import Component from "@tunnel-components/@pages/supervision/camera/settings/component";
import * as React from "react";
import {
  CameraByIdLoadedActionCreator,
  CameraRemoveActionCreator,
  CameraUpdateActionCreator,
  GetZoneByIdCameraResetActionCreator,
  CameraInhibitionsLoadedActionCreator,
  IncidentTypesLoadedActionCreator,
  CameraSettingActionCreator,
  SystemSettingsActionCreator,
} from "@tunnel-store/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";
import * as Paths from "@tunnel-enums/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onDisabledImpact
 * @name onSortDynamic
 * @name onDisabledDesc
 * @name onSubmit
 * @name onOpenCameraInformation
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { number }       state.cameraIdentifiant
     * @property { string }       state.action
     * @property { boolean }      state.inhibateBoolean
     * ......
     */
    this.state = {
      cameraIdentifiant: props.match.params.id,
      cameraSetting: false,
      disabled: false,
      disabledcamera: true,
      disableddesc: true,
      editioncamerasuccees: false,
      editioncameraerror: false,
      editionErrorIsDuplication: false,
      inhibateBoolean: true,
      infrastructureIsOpen: false,
      invalidSynthaxe: false,
      ipCameraBoolean: false,
      fluxLive: [true, false],
      less: false,
      modified: true,
      more: false,
      succeesNext: false,
      remouvecamera: false,
      sectionCameraError: false,
      suppressioncameraerror: false,
      suppressioncamerasuccees: false,
      typeCameraError: false,
      viewCameraError: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChange = this.onChange.bind(this);
    this.onInhibateAllIncident = this.onInhibateAllIncident.bind(this);
    this.onDisabledImpact = this.onDisabledImpact.bind(this);
    this.onDisabledDesc = this.onDisabledDesc.bind(this);
    this.onOpenCameraInformation = this.onOpenCameraInformation.bind(this);
    this.onCloseCamera = this.onCloseCamera.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onRemouveCamera = this.onRemouveCamera.bind(this);
    this.onEditeCamera = this.onEditeCamera.bind(this);
    this.onUpdateCamera = this.onUpdateCamera.bind(this);

    this.onGetVueValue = this.onGetVueValue.bind(this);
    this.onGetTypeValue = this.onGetTypeValue.bind(this);
    this.onGetSectionValue = this.onGetSectionValue.bind(this);
    this.onChangeCameraLocalization = this.onChangeCameraLocalization.bind(
      this
    );

    this.onChangeCamera = this.onChangeCamera.bind(this);

    //
    this.onInfrastructureIsOpen = this.onInfrastructureIsOpen.bind(this);

    //
    this.onFluxLive = this.onFluxLive.bind(this);
  }

  /**
   * @method onFluxLive
   * @description : Changement de l'état des boutons
   * @param {  number }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onFluxLive = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @name fluxLive
     * @type boolean[]
     */
    const fluxLive: boolean[] = [];
    {
      /** vérification de l'existence de l'élement  */
    }
    for (let i = 0; i < Math.ceil(this.state.fluxLive.length); i++) {
      fluxLive.push(false);
    }

    fluxLive[param] = true; // Changement de la valeur du tableau!!!

    if (param === 1) {
      if (!window.localStorage.getItem("fluxparam")) {
        // window.location.reload();
        window.localStorage.setItem("fluxparam", "1");
      }
    } else {
      window.localStorage.removeItem("fluxparam");
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ fluxLive })); // Cloner la valeur du State
  };

  /**
   * @method onSectionCameraState
   * @description : Définir le sens des sections ( sens 1  ou sens 2)
   * @param {  void }
   * @return { void }
   * @infos "https://reactjs.org"
   */
  public onSectionCameraState = (value: any): void => {
    if (Number(value) === 1) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ directionCamera: "1 " }));
    } else if (Number(value) === 2) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ directionCamera: "2" }));
    } else if (
      Number(value) !== 2 &&
      Number(value) !== 1 &&
      Number(value) !== 3
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ directionCamera: "" }));
    } else if (Number(value) === 3) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ directionCamera: "2" }));
    }
  };
  /**
   * @method onCreatedAnCamera
   * @param {  any } event
   * @infos "https://reactjs.org"
   */
  public onCreatedAnCamera = (cameraUpdateinfos: any) => {
    this.updateCamera(cameraUpdateinfos);
  };

  /**
   * @action " Suppresion de la caméra "
   * @method
   * @name onInfrastructureIsOpen
   * @param { any }  event
   * @return { void }
   */
  public onInfrastructureIsOpen = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      infrastructureIsOpen: !this.state.infrastructureIsOpen,
      invalidSynthaxe: false,
    }));
  };
  /**
   *
   * @method onGetVueValue
   * @description : On recupère la valeur des inputs
   * @param {  any } value
   * @infos "https://reactjs.org"
   */
  public onGetVueValue = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }
    if (!Lodash.isEqual(value, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        invalidSynthaxe: false,
        ipCameraBoolean: false,
        less: false,
        modified: true,
        more: false,
        sectionCameraError: false,
        typeCameraError: false,
        viewCamera: value,
        viewCameraError: false,
      }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        viewCamera: "",
        viewCameraError: true,
        invalidSynthaxe: false,
        ipCameraBoolean: false,
      }));
    }
  };
  /**
   *
   * @method onGetSectionValue
   * @description : On recupère la valeur des inputs
   * @param {  any } value
   * @infos "https://reactjs.org"
   */
  public onGetSectionValue = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }

    if (!Lodash.isEqual(value, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        invalidSynthaxe: false,
        ipCameraBoolean: false,
        less: false,
        modified: true,
        more: false,
        sectionCameraError: false,
        sectionCameraId: value,
        typeCameraError: false,
        viewCameraError: false,
      }));
      this.onSectionCameraState(value); // Change direction
    } else {
      this.setState({
        sectionCameraError: true,
        invalidSynthaxe: false,
        ipCameraBoolean: false,
      });
    }
  };
  /**
   *
   * @method onGetTypeValue
   * @description : On recupère la valeur des inputs
   * @param {  any } value
   * @infos "https://reactjs.org"
   */
  public onGetTypeValue = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }

    if (!Lodash.isEqual(value, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        editioncameraerror: false,
        editioncamerasuccees: false,
        invalidSynthaxe: false,
        ipCameraBoolean: false,
        less: false,
        modified: true,
        more: false,
        sectionCameraError: false,
        typeCamera: value,
        typeCameraError: false,
        viewCameraError: false,
      }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        typeCamera: "",
        typeCameraError: true,
        ipCameraBoolean: false,
      }));
    }
  };

  /**
   * @action " Empêcher la mutation du state "
   * @method
   * @name onChangeCameraLocalization
   * @param { any }  event
   * @return { void }
   */
  public onChangeCameraLocalization = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    console.log("modif", event.target.name, Number(event.target.value));
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState({
      invalidSynthaxe: false,
      ipCameraBoolean: false,
      editioncameraerror: false,
      editioncamerasuccees: false,
      less: false,
      modified: true,
      more: false,
      [event.target.name]: Number(event.target.value),
    });
  };

  /**
   * @action " Empêcher la mutation du state "
   * @method
   * @name onChangeCamera
   * @param { any }  event
   * @return { void }
   */
  public onChangeCamera = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState({
      invalidSynthaxe: false,
      ipCameraBoolean: false,
      editioncameraerror: false,
      editioncamerasuccees: false,
      less: false,
      modified: true,
      more: false,
      [event.target.name]: event.target.value,
    });
  };
  /**
   * Cette méthode ouvre une fênètre
   * @action " Suppresion de la caméra "
   * @method
   * @name onEditeCamera
   * @param { any }  event
   * @return { void }
   */
  public onEditeCamera = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      less: false,
      modified: true,
      more: false,
      editioncameraerror: false,
      ipCameraBoolean: false,
      disabledcamera: !this.state.disabledcamera,
      editioncamerasuccees: false,
    }));
  };
  /**
   * Cette méthode ouvre une fênètre
   * @action " Suppresion de la caméra "
   * @method
   * @name onUpdateCamera
   * @param { any }  event
   */
  public onUpdateCamera = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    let ipCameraUpdate: any;
    let lineairelocalisationCameraUpdate: any;
    let nameCameraUpdate: any;
    let proposedMaxDistanceUpdate: any;

    if (
      !Lodash.isUndefined(this.state.ipCamera) &&
      !Lodash.isEqual(this.state.ipCamera, "")
    ) {
      ipCameraUpdate = this.state.ipCamera;
    } else {
      ipCameraUpdate = this.state.ipCameraGrid;
    }
    if (
      !Lodash.isUndefined(this.state.lineairelocalisationCamera) &&
      !Lodash.isEqual(this.state.lineairelocalisationCamera, "")
    ) {
      lineairelocalisationCameraUpdate = this.state.lineairelocalisationCamera;
    } else {
      lineairelocalisationCameraUpdate = this.state
        .lineairelocalisationCameraGrid;
    }

    if (
      Lodash.isUndefined(this.state.proposedMaxDistance) ||
      Lodash.isEqual(this.state.proposedMaxDistance, "")
    ) {
      proposedMaxDistanceUpdate = null;
    } else {
      proposedMaxDistanceUpdate = Number(this.state.proposedMaxDistance);
    }

    console.log(
      "test",
      this.state.proposedMaxDistance,
      proposedMaxDistanceUpdate
    );
    if (
      !Lodash.isUndefined(this.state.nameCamera) &&
      !Lodash.isEqual(this.state.nameCamera, "")
    ) {
      nameCameraUpdate = this.state.nameCamera;
    } else {
      nameCameraUpdate = this.state.nameCameraGrid;
    }

    {
      /** Vérification de la variable */
    }
    if (Utils.validatorString(nameCameraUpdate)) {
      {
        /** Vérification de la variable */
      }

      if (Lodash.isEqual(ipCameraUpdate, "")) {
        /**
         * @description : retourne un object
         * @const
         * @name cameraUpdateinfos
         * @type { object  }
         */
        const cameraUpdateinfos: any = {
          nameCameraUpdate,
          proposedMaxDistance: proposedMaxDistanceUpdate,
          directionCamera: this.state.directionCamera,
          idCamera: param,
          ipCameraUpdate,
          lineairelocalisationCameraUpdate,
          infrastructureCamera: this.state.infrastructureCamera,
          sectionCamera: this.state.sectionCameraId,
          typeCamera: this.state.typeCamera,
          viewCamera: this.state.viewCamera,
          stream: this.state.stream,
          proxyCode: this.state.proxyCode,
        };

        {
          /** Mise à jour des CAM */
        }
        this.onCreatedAnCamera(cameraUpdateinfos); // Misa à jour
      } else {
        if (Utils.validatorIpValue(ipCameraUpdate)) {
          /**
           * @description : retourne un object
           * @const
           * @name cameraUpdateinfos
           * @type { object  }
           */
          const cameraUpdateinfos: any = {
            nameCameraUpdate,
            proposedMaxDistance: proposedMaxDistanceUpdate,
            directionCamera: this.state.directionCamera,
            idCamera: param,
            ipCameraUpdate,
            lineairelocalisationCameraUpdate,
            infrastructureCamera: this.state.infrastructureCamera,
            sectionCamera: this.state.sectionCameraId,
            typeCamera: this.state.typeCamera,
            viewCamera: this.state.viewCamera,
            stream: this.state.stream,
            proxyCode: this.state.proxyCode,
          };

          {
            /** Mise à jour des CAM */
          }
          this.onCreatedAnCamera(cameraUpdateinfos); // Misa à jour
        } else {
          this.setState((state: any) => ({ ipCameraBoolean: true }));
        }
      }

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ invalidSynthaxe: false }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ invalidSynthaxe: true }));
    }
  };
  /**
   * Cette méthode ouvre une fênètre
   * @action " Suppresion de la caméra "
   * @method
   * @name updateCamera
   * @param { any }  cameraUpdateinfos
   * @return { void }
   */
  public updateCamera = (cameraUpdateinfos: any): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ loading: true, ipCameraBoolean: false }));
    {
      /** action creator */
    }
    this.props.CameraUpdateActionCreator(cameraUpdateinfos).then(() => {
      this.props.CameraByIdLoadedActionCreator(this.props.match.params.id); // Chargement des caméras
      this.props
        .GetZoneByIdCameraResetActionCreator() // Reinisalisation des zones de masques
        .then(() => {
          this.props
            .CameraInhibitionsLoadedActionCreator(this.props.match.params.id) // Chargement des types d'incidents
            .then(() => this.props.IncidentTypesLoadedActionCreator());
        }) // Chargement des Inhibitions pour la caméra
        .then(() => this.setState({ loading: false }));
    });
  };
  /**
   * Cette méthode ouvre une fênètre
   * @action " Suppresion de la caméra "
   * @method
   * @name onCloseCamera
   * @param { any }  event
   * @return { void }
   */
  public onCloseCamera = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      remouvecamera: !this.state.remouvecamera,
      cameraSetting: false,
      ipCameraBoolean: false,
    });
    this.setState((state: any) => ({
      suppressioncamerasuccees: false,
      suppressioncameraerror: false,
    }));
  };

  /**
   * Cette méthode ouvre une fênètre
   * @action " Supprimer une camera "
   * @method
   * @name onRemouveCamera
   * @param { any }  event
   * @param { number }  param
   */
  public onRemouveCamera = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ loading: true, ipCameraBoolean: false }));

    this.props.CameraRemoveActionCreator(param).then(() => {
      this.setState((state: any) => ({ loading: false }));
    });
    // return  this.setState({ suppressioncamerasuccees: !this.state.suppressioncamerasuccees})
  };

  /**
   *
   * @param event fermeture de la fenêtre
   */

  public onClose = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      cameraSetting: !this.state.cameraSetting,
      disabledcamera: true,
      infrastructureIsOpen: false,
      ipCameraBoolean: false,
      invalidSynthaxe: false,
      succeesNext: false,
      // restauration des valeurs originales
      nameCamera: state.originalValues.code,
      nameCameraGrid: state.originalValues.code,
      tubeCamera:
        state.originalValues.section && state.originalValues.section.name,
      tubeCameraGrid:
        state.originalValues.section && state.originalValues.section.name, // clone
      typeCamera: state.originalValues.type,
      typeCameraGrid: state.originalValues.type, // clone
    }));
  };

  /**
   * Cette méthode ouvre une fênètre
   * @action " Changement du détails de la caméra "
   * @method
   * @name onOpenCameraInformation
   * @param { any }  event
   * @return { void }
   */
  public onOpenCameraInformation = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      cameraSetting: !this.state.cameraSetting,
      disabledcamera: true,
      infrastructureIsOpen: false,
      ipCameraBoolean: false,
      invalidSynthaxe: false,
      succeesNext: false,
    }));
  };
  /**
   * Cette méthode mute le state
   * @action " Changement de l'état des boutons "
   * @method
   * @name onDisabledDesc
   * @param { any }  event
   * @return { void }
   */
  public onDisabledDesc = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      disableddesc: !this.state.disableddesc,
      ipCameraBoolean: false,
      invalidSynthaxe: false,
    }));
  };
  /**
   * Cette méthode mute le state
   * @action " Changement de l'état des boutons "
   * @method
   * @name onDisabledImpact
   * @param { any }  event
   * @return { void }
   */
  public onDisabledImpact = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    return this.setState((state: any) => ({
      disabled: !this.state.disabled,
      ipCameraBoolean: false,
      invalidSynthaxe: false,
    }));
  };
  /**
   * Mise à jour des inhibition pour chaque
   * caméra
   * Envoie des inhibitions au back avec l'api
   * @action "  "
   * @method
   * @name onSubmit
   * @param { any }  event
   * @return { void }
   */
  public onSubmit = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      loading: true,
      succeesNext: false,
      ipCameraBoolean: false,
      invalidSynthaxe: false,
    }));
    this.props
      .CameraSettingActionCreator(this.state)
      .then(() => this.setState((state: any) => ({ loading: false })));
  };
  /**
   * Cette méthode mute le state
   * @action " détails caméra  "
   * @method
   * @name onUpdateValue
   * @param { any }  event
   * @return { void }
   */
  public onUpdateValue = (Elem: any): void => {
    /** Configuration dela viriable globale ,
     * L'objet window représente une fenêtre contenant un document DOM
     */
    const API_URL = "env";
    {
      /** vérification de l'existence de l'élement  */
    }

    if (Elem && typeof Elem === "object") {
      const formatDate = (date: string) => {
        const split = date.split(" ");
        const day = split[0].split("-");
        const hour = split[1].split(":");
        return `${day.reverse().join("/")} ${hour[0]}:${hour[1]}`;
      };
      console.log("Elem", Elem);
      this.setState((state: any) => ({
        originalValues: Elem,
        connected: Elem.connected,
        directionCamera: Elem.direction,
        idCamera: Elem.id,
        ipCamera: Elem.ip,
        ipCameraGrid: Elem.ip, // clone
        // infrastructureCamera:Elem.route,
        infrastructureCamera: window[API_URL].INFRASTRUCTURE,
        lineairelocalisationCamera: Elem.location,
        lineairelocalisationCameraGrid: Elem.location, // clone
        liveIncidentUrl: Elem.liveIncidentUrl,
        marqueCamera: Elem.brand,
        modeleCamera: Elem.model,
        move: Elem.move,
        nameCamera: Elem.code,
        nameCameraGrid: Elem.code, // clone
        lastReadDate: formatDate(Elem.lastReadDate),
        lastUpdateDate: formatDate(Elem.lastUpdateDate),
        createDate: formatDate(Elem.createDate),
        proposedMaxDistance: Elem.proposedMaxDistance
          ? Number(Elem.proposedMaxDistance) > 110
            ? 110
            : Number(Elem.proposedMaxDistance)
          : 110,
        proxyCode: Elem.proxyCode,
        stream: Elem.stream,
        noSignal: Elem.noSignal,
        // projectCamera:Elem.project,
        projectCamera: window[API_URL].PROJECT,
        sectionCamera: Elem.section && Elem.section.name,
        sectionCameraGrid: Elem.section && Elem.section.name, // clone
        sectionCameraId: Elem.section && Elem.section.id,
        sectionCameraIdGrid: Elem.section && Elem.section.id,
        snapshotCamera: Elem.snapshot,
        tubeCamera: Elem.section && Elem.section.name,
        tubeCameraGrid: Elem.section && Elem.section.name, // clone
        typeCamera: Elem.type,
        typeCameraGrid: Elem.type, // clone
        viewCamera: Elem.view,
        viewCameraGrid: Elem.view, // clone
        ...state,
      }));
    }
    // if (!Lodash.isUndefined(Elem) && Lodash.isObject(Elem)) {

    // }
  };
  /**
   * Cette méthode mute le state
   * @action " Cette fonction cree ou désactive toutes les inhibitions  "
   * @method
   * @name onInhibateAllIncident
   * @param { any }  event
   * @return { void }
   */
  public onInhibateAllIncident = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name inhibateBoolean
     * @type boolean[]
     */
    const inhibateBoolean: boolean = !this.state.inhibateBoolean;
    /**
     * @constant
     * @name checkTypesIncidents
     * @type boolean[]
     */
    const checkTypesIncidents: any[] = [];
    /**
     * @constant
     * @name incidenTypeIdentifiantByCheckBox
     * @type any[]
     */
    const incidenTypeIdentifiantByCheckBox: any[] = [];
    /**
     * @constant
     * @name incidenTypeIdentifiant
     * @type any[]
     */
    const incidenTypeIdentifiant: any[] = this.state.incidenTypeIdentifiant;

    {
      /** Comparaison */
    }
    if (inhibateBoolean === true) {
      {
        /** boucle  */
      }
      for (
        let i = 0;
        i < Math.ceil(this.state.checkTypesIncidents.length);
        i++
      ) {
        checkTypesIncidents.push(false);
        incidenTypeIdentifiantByCheckBox.push(null);
      }
    } else if (inhibateBoolean === false) {
      {
        /** boucle  */
      }
      for (
        let i = 0;
        i < Math.ceil(this.state.checkTypesIncidents.length);
        i++
      ) {
        checkTypesIncidents.push(true);
        incidenTypeIdentifiantByCheckBox[i] = incidenTypeIdentifiant[i];
      }
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      inhibateBoolean,
      checkTypesIncidents,
      incidenTypeIdentifiantByCheckBox,
      succeesNext: false,
    }));
  };
  /**
   * Tri des objects / tableau  par ordre croissant ou décroissant
   * @action "  "
   * @method
   * @name onSortDynamic
   * @param { any }  Elem
   * @return { any }
   */
  public onSortDynamic = (Elem: any): any => {
    {
      /**  test du type ou existence du paramètre */
    }
    if (
      Lodash.isArray(Elem) &&
      !Lodash.isUndefined(Elem) &&
      !Lodash.isNull(Elem)
    ) {
      {
        /** renvoie du tableau trié */
      }
      return Elem.sort((a: any, b: any) =>
        a.id > b.id ? 1 : b.id > a.id ? -1 : 0
      );
    }
  };
  /**
   * @description "  "
   * @method
   * @name onChange
   * @param { any } event
   * @param { number } param
   */
  public onChange = (param: number) => (event: any) => {
    /**
     * @constant
     * @name checkTypesIncidents
     * @type boolean[]
     */
    const checkTypesIncidents: any[] = [];
    /**
     * @constant
     * @description :
     * @name incidenTypeIdentifiant
     * @type number[]
     */
    const incidenTypeIdentifiantByCheckBox: any[] = this.state
      .incidenTypeIdentifiantByCheckBox;
    {
      /** Boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.checkTypesIncidents.length); i++) {
      checkTypesIncidents[i] = this.state.checkTypesIncidents[i];
    }
    checkTypesIncidents[param] = !this.state.checkTypesIncidents[param];
    {
      /** Comparaison */
    }
    if (checkTypesIncidents[param] === true) {
      incidenTypeIdentifiantByCheckBox[param] = { id: Number(event.target.id) };
    } else {
      incidenTypeIdentifiantByCheckBox[param] = null;
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      checkTypesIncidents,
      incidenTypeIdentifiantByCheckBox,
      succeesNext: false,
    }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ loading: true });
    {
      /** dispatch actions  */
    }
    this.props.CameraByIdLoadedActionCreator(this.props.match.params.id); // Chargement des caméras
    this.props
      .GetZoneByIdCameraResetActionCreator() // Reinisalisation des zones de masques
      .then(() => {
        this.props
          .CameraInhibitionsLoadedActionCreator(this.props.match.params.id) // Chargement des types d'incidents
          .then(() => this.props.IncidentTypesLoadedActionCreator());
      }); // Chargement des Inhibitions pour la caméra
    // .then( () => this.setState({loading: false}))

    if (window.localStorage.getItem("fluxparam")) {
      /**
       * @constant
       * @name fluxLive
       * @type boolean[]
       */
      const fluxLive: boolean[] = [];
      {
        /** vérification de l'existence de l'élement  */
      }
      for (let i = 0; i < Math.ceil(this.state.fluxLive.length); i++) {
        fluxLive.push(false);
      }

      fluxLive[1] = true; // Changement de la valeur du tableau!!!

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ fluxLive })); // Cloner la valeur du State
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      cameraIdentifiant: "",
      cameraSetting: false,
      disabled: true,
      disabledcamera: true,
      disableddesc: true,
      inhibateBoolean: false,
      ipCameraBoolean: false,
      loading: false,
      succeesNext: false,
    }));
    {
      /** Mise à jour des zones */
    }
    this.props.GetZoneByIdCameraResetActionCreator();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison des  */
    }
    if (nextProps.getCameraDetails !== this.props.getCameraDetails) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (
        !Lodash.isUndefined(nextProps.getCameraDetails) &&
        Lodash.isUndefined(this.props.error)
      ) {
        this.onUpdateValue(nextProps.getCameraDetails);
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ loading: false }));
      }
      {
        /** Comparaison des  */
      }
    } else if (nextProps.getIncidentTypes !== this.props.getIncidentTypes) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (
        !Lodash.isUndefined(nextProps.getIncidentTypes) &&
        Lodash.isUndefined(this.props.error)
      ) {
        /**
         * @constant
         * @description : le tableau contient les etats des bouton
         * @name  checkTypesIncidents
         * @types boolean[]
         */
        const checkTypesIncidents: boolean[] = [];
        /**
         * @constant
         * @description : Tableau des identifiants de types d'incident
         * @name  incidenTypeIdentifiant
         * @types boolean[]
         */
        const incidenTypeIdentifiant: any[] = [];
        /**
         * @constant
         * @name  incidenTypeIdentifiantByCheckBox
         * @types boolean[]
         */
        const incidenTypeIdentifiantByCheckBox: any[] = [];
        /**
         * @constant
         * @description : tableau Inhibition
         * @name  getIncident
         * @types any[]
         */
        const getIncident: any[] = nextProps.getIncidentTypes;
        /**
         * @constant
         * @description : Filtre du tableau des types d'inhibition
         * @name  getIncident
         * @types any[]
         */
        // const filterIncidentTypes : any[] =getIncident && this.onSortDynamic(Utils.transformObjectToArray(getIncident).filter( ( elem : any) => elem.id !== 2 && elem.id !== 3 ))  ;
        const filterIncidentTypes: any[] =
          getIncident &&
          this.onSortDynamic(
            Utils.transformObjectToArray(getIncident).filter(
              (elem: any) => elem !== null
            )
          );
        for (let i = 0; i < Math.ceil(filterIncidentTypes.length); i++) {
          {
            /** Vérification de l'existence d'une variable */
          }
          if (!Lodash.isUndefined(filterIncidentTypes)) {
            {
              /** Vérification de l'existence d'une variable */
            }
            if (
              !Lodash.isUndefined(this.props.getCameraInhibitions) &&
              Lodash.isEmpty(this.props.getCameraInhibitions.incidentTypes)
            ) {
              checkTypesIncidents.push(false);

              incidenTypeIdentifiantByCheckBox.push(null);
            } else if (
              !Lodash.isUndefined(this.props.getCameraInhibitions) &&
              !Lodash.isEmpty(this.props.getCameraInhibitions.incidentTypes)
            ) {
              /**
               * @constant
               * @name findElementIn2DifferentArray
               * @types any[]
               */
              const findElementIn2DifferentArray: any = this.props.getCameraInhibitions.incidentTypes.filter(
                (elem: any) => elem.id === filterIncidentTypes[i].id
              );

              checkTypesIncidents.push(
                findElementIn2DifferentArray.length === 1
              );

              if (findElementIn2DifferentArray.length === 1) {
                incidenTypeIdentifiantByCheckBox[i] = {
                  id: findElementIn2DifferentArray[0].id,
                };
              } else {
                incidenTypeIdentifiantByCheckBox[i] = null;
              }
            }
            incidenTypeIdentifiant.push({ id: filterIncidentTypes[i].id });
          }
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({
          checkTypesIncidents,
          filterIncidentTypes,
          incidenTypeIdentifiant,
          incidenTypeIdentifiantByCheckBox,
          loading: false,
        }));
      }
    } else if (nextProps.error !== this.props.error) {
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ errorserver: true, loading: false }));
      }
    } else if (nextProps.settingSuccees !== this.props.settingSuccees) {
      if (!Lodash.isUndefined(nextProps.settingSuccees)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ succeesNext: true, loading: false }));
      }
    } else if (
      nextProps.cameraremovesuccees !== this.props.cameraremovesuccees
    ) {
      if (!Lodash.isUndefined(nextProps.cameraremovesuccees)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({
          suppressioncamerasuccees: true,
          suppressioncameraerror: false,
        }));

        /**
         * @constant
         * @description :
         * @name  options
         * @types any
         */
        const _URL: any = Paths.PathsNamesEnums.CAMERAHOME;

        // settime out
        setTimeout(() => this.props.history.push(_URL), 2500); // redirection parès 2.5s
      }
    } else if (nextProps.cameraremoveerror !== this.props.cameraremoveerror) {
      if (!Lodash.isUndefined(nextProps.cameraremoveerror)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({
          suppressioncameraerror: true,
          suppressioncamerasuccees: false,
        }));
      }
    } else if (
      nextProps.cameraupdatesuccees !== this.props.cameraupdatesuccees
    ) {
      if (!Lodash.isUndefined(nextProps.cameraupdatesuccees)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState({
          editioncamerasuccees: true,
          editioncameraerror: false,
        });

        setTimeout(
          () =>
            this.setState((state: any) => ({
              editioncameraerror: false,
              cameraSetting: false,
              editioncamerasuccees: false,
            })),
          2500
        );
      }
    } else if (nextProps.cameraupdateerror !== this.props.cameraupdateerror) {
      if (!Lodash.isUndefined(nextProps.cameraupdateerror)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({
          editioncameraerror: true,
          editioncamerasuccees: false,
          editionErrorIsDuplication:
            nextProps.cameraupdateerror.indexOf("409") !== -1,
          // restauration des valeurs originales
          nameCamera: state.originalValues.code,
          nameCameraGrid: state.originalValues.code,
          tubeCamera:
            state.originalValues.section && state.originalValues.section.name,
          tubeCameraGrid:
            state.originalValues.section && state.originalValues.section.name, // clone
          typeCamera: state.originalValues.type,
          typeCameraGrid: state.originalValues.type, // clone
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.checkTypesIncidents !== this.state.checkTypesIncidents) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (!Lodash.isUndefined(this.state.checkTypesIncidents)) {
        if (this.state.checkTypesIncidents.some((elem: any) => elem === true)) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any) => ({ inhibateBoolean: false }));
        } else if (
          this.state.checkTypesIncidents.every((elem: any) => elem === false)
        ) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any) => ({ inhibateBoolean: true }));
        }
      }

      {
        /** Comparaison des props */
      }
    } else if (prevState.sectionCameraId !== this.state.sectionCameraId) {
      this.onSectionCameraState(this.state.sectionCameraId); // Modification de direction ( sens )
      // this.setState((state: any) =>({noCouverture: false}))
      /**
       * @deprecated
       */
      // if( Number(this.state.sectionCameraId) === 3 ){
      //    { /** Empêcher la mutation du state */}
      //    this.setState((state: any) =>({noCouverture: true}))

      //   }else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ noCouverture: false }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */

  public render() {
    return (
      <Component
        {...this.state}
        {...this.props}
        onOpenCameraInformation={this.onOpenCameraInformation}
        onClose={this.onClose}
        onDisabledDesc={this.onDisabledDesc}
        onDisabledImpact={this.onDisabledImpact}
        onChange={this.onChange}
        onInhibateAllIncident={this.onInhibateAllIncident}
        onSubmit={this.onSubmit}
        onCloseCamera={this.onCloseCamera}
        onRemouveCamera={this.onRemouveCamera}
        onEditeCamera={this.onEditeCamera}
        onUpdateCamera={this.onUpdateCamera}
        onGetVueValue={this.onGetVueValue}
        onGetTypeValue={this.onGetTypeValue}
        onGetSectionValue={this.onGetSectionValue}
        onChangeCameraLocalization={this.onChangeCameraLocalization}
        onChangeCamera={this.onChangeCamera}
        onInfrastructureIsOpen={this.onInfrastructureIsOpen}
        onFluxLive={this.onFluxLive}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    error: state.CameraByIdLoaded.error,
    cameraremovesuccees: state.CameraRemove.data,
    cameraremoveerror: state.CameraRemove.error,
    cameraupdatesuccees: state.CameraUpdate.data,
    cameraupdateerror: state.CameraUpdate.error,
    getCameraDetails: state.CameraByIdLoaded.data,
    getCameraInhibitions: state.CameraInhibitionsLoaded.data,
    getIncidentTypes: state.IncidentTypesLoaded.data,
    sections: state.SystemSettings.data,
    settingSuccees: state.CameraSetting.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  CameraRemoveActionCreator,
  CameraUpdateActionCreator,
  CameraSettingActionCreator,
  CameraInhibitionsLoadedActionCreator,
  GetZoneByIdCameraResetActionCreator,
  CameraByIdLoadedActionCreator,
  IncidentTypesLoadedActionCreator,
  SystemSettingsActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/settings/container.tsx